module.exports = __webpack_public_path__ + "img/style-4.7538d6c1.jpg";